import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=74731b51&scoped=true&lang=pug&"
import script from "./SettingItem.vue?vue&type=script&lang=ts&"
export * from "./SettingItem.vue?vue&type=script&lang=ts&"
import style0 from "./SettingItem.vue?vue&type=style&index=0&id=74731b51&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74731b51",
  null
  
)

export default component.exports